
export interface DriveFile {
  id: string
  title: string
  alternateLink: string
  thumbnailUrl: string
}

export interface SharedDriveFile {
  driveFile: DriveFile
  shareMode: 'UNKNOWN_SHARE_MODE' | 'VIEW' | 'EDIT' | 'STUDENT_COPY'
}

export interface YouTubeVideo {
  id: string
  title: string
  alternateLink: string
  thumbnailUrl: string
}

export interface Link {
  url: string
  title: string
  thumbnailUrl: string
}

export interface Form {
  formUrl: string
  responseUrl: string
  title: string
  thumbnailUrl: string
}

export interface MaterialType {
  driveFile?: SharedDriveFile
  youtubeVideo?: YouTubeVideo
  link?: Link
  form?: Form
}

class Material implements MaterialType {
  driveFile?: any
  youtubeVideo?: any
  link?: any
  form?: any

  constructor(material: MaterialType) {
    this.driveFile = material.driveFile;
    this.youtubeVideo = material.youtubeVideo;
    this.link = material.link;
    this.form = material.form;
  }
}

export default Material;
